"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M13.5 23a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3Zm1-2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5Zm0-2a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5ZM12 0c4.411 0 8 3.589 8 8 0 1.92-1.089 3.567-2.165 5.031l-.338.457c-.201.27-.4.537-.59.803a4.628 4.628 0 0 0-.758 1.732C15.891 17.188 14.912 18 13.768 18h-3.536c-1.087 0-2.025-.734-2.337-1.805l-.044-.172a4.621 4.621 0 0 0-.758-1.732l-.29-.4-.638-.86C5.089 11.567 4 9.921 4 8c0-4.411 3.589-8 8-8Zm0 1C8.14 1 5 4.141 5 8c0 1.51.831 2.864 1.77 4.165l.536.726c.205.275.407.548.601.818a5.69 5.69 0 0 1 .921 2.098c.155.703.733 1.193 1.404 1.193h3.536c.671 0 1.249-.49 1.404-1.193a5.688 5.688 0 0 1 .921-2.098l.296-.407.84-1.137C18.17 10.865 19 9.509 19 8c0-3.859-3.14-7-7-7Z",
    clipRule: "evenodd"
  })]
});